import { gql } from "@apollo/client";
import moment from 'moment';

const GET_HISTORIAL_CONEXIONES = gql`
    query esquemaHistoricoByIdEvaluacion($idEvaluacion: Int!) {
        esquemaHistoricoByIdEvaluacion(idEvaluacion: $idEvaluacion) {
            idEvaluacion
            idDia
            fechaAlta
            idUsuario
            idUsuarioNavigation {
                nombre
                apellido
            }
        }
    }
`;

export default GET_HISTORIAL_CONEXIONES;

export const adaptHistorialConexion = (historialConexion) => {
  return {
    idEvaluacion: historialConexion?.idEvaluacion,
    idDia: historialConexion?.idDia,
    fechaAlta: historialConexion?.fechaAlta,
    idUsuario: historialConexion?.idUsuario,
    usuario: `${historialConexion?.idUsuarioNavigation?.apellido}, ${historialConexion?.idUsuarioNavigation?.nombre}`
  };
};

export const adaptHistorialConexionesArray = (historialConexiones) => {
  return structuredClone(historialConexiones)?.
  map((historialConexion) => adaptHistorialConexion(historialConexion));
};

export const groupEvaluations = (evaluations) => {
  // Primero, normalizamos las fechas sin milisegundos usando moment
  const groupedEvaluations = evaluations.reduce((acc, current) => {
    // Convertir la fecha a un formato sin milisegundos
    const normalizedDate = moment(current.fechaAlta).format('YYYY-MM-DD HH:mm:ss');

    // Crear una clave única combinando idUsuario y fechaAlta normalizada
    const groupKey = `${current.idUsuario}-${normalizedDate}`;

    // Si no existe este grupo, lo inicializamos
    if (!acc[groupKey]) {
      acc[groupKey] = {
        ...current,
        fechaAlta: normalizedDate, // Usamos la fecha normalizada
        dias: [current.idDia]
      };
    } else {
      // Si ya existe, añadimos el día al grupo
      acc[groupKey].dias.push(current.idDia);
    }

    return acc;
  }, {});

  // Convertir el objeto agrupado en un array
  return Object.values(groupedEvaluations).map((group) => ({
    ...group,
    dias: group.dias.sort((a, b) => a - b) // Ordenar los días
  })).
  sort((a, b) => moment(b.fechaAlta).diff(moment(a.fechaAlta)));
};

// Ejemplo de uso:
// const resultado = groupEvaluations(arrayDeEvaluaciones);